"use strict";
checkList.classy.controller({
    name: 'ChoiceController',
    inject: ['$scope', 'ApplicationService', 'PutService'],
    init: function () 
    {
        this.$.versionNo = versionNo;
        this.$.ApplicationService = this.ApplicationService;
    },
    getIncludeDiv: function () 
    {
        return 'fast/submodules/schoolside/applications/submodules/applicationOverview/submodules/checkList/partials/' + this.$.answer[this.$.choice] + '.html?v=' + this.$.versionNo;
    }
});
